import React from 'react';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import Truncate from 'react-truncate';
import { dateFormatter } from '../../../../helpers';
import WysiwygField from '../../../WysiwygField';
import ThemesLabels from '../../../ThemesLabels';

import {
  SCREEN_TABLET,
  TAXONOMY_MEDIA_CATEGORY_PUBLICATION,
  TAXONOMY_MEDIA_CATEGORY_CODE,
} from '../../../../config/constants';

const EntityTeaserSmall = ({ node, typeLabel }) => {
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;

  const title = node.title[0].value;
  const lang = 'nl';
  const image = node.field_media_item[0];
  const mediaCategoryId = node.field_media_category?.[0]?.target_id;
  const isOfTypeCodeOrPublication = (
    mediaCategoryId === TAXONOMY_MEDIA_CATEGORY_PUBLICATION ||
    mediaCategoryId === TAXONOMY_MEDIA_CATEGORY_CODE
  );
  const generatedImage = node?.field_media_item[0]?.entity?.field_poster_image?.[0];
  if (generatedImage) {
    generatedImage.bundle = 'image';
    generatedImage.title = image.title || title;
  }

  const themes = node.field_themes;
  const date = node.field_publish_date?.[0]?.value || node.created[0]?.value;
  const url = node.paths.nl;
  const summary = node.body?.[0]?.summary || node.body?.[0]?.value;

  const noImage = !((image && image.bundle === 'image') || generatedImage);

  return (
    <div className={`TeaserSmall ${noImage ? 'TeaserSmall--noImage' : ''}`}>
      {((image && image.bundle === 'image') || generatedImage) &&
        <div className="TeaserSmall__image">
          <div className="overlay" />
          <DynamicMediaItem
            className={isOfTypeCodeOrPublication && 'isOfTypeCodeOrPublication'}
            media={image.bundle === 'image' ? image : generatedImage}
            imageAspectRatio={isOfTypeCodeOrPublication ? '1_1_41' : '1_1'}
          />
          <div className="triangle triangle--small" />
        </div>}

      <div className="TeaserSmall__info">
        <p className="TeaserSmall__info__type">
          {typeLabel}
        </p>
        <span className="dot">&bull;</span>
        <p>{dateFormatter(date, lang, isMobile && true)}</p>
      </div>
      <div className="TeaserSmall__content">
        <div className="TeaserSmall__heading">
          <CoreLink className="teaser-link" to={url}>
            <Truncate lines={4} ellipsis="...">
              {title}
            </Truncate>
          </CoreLink>
        </div>
        {summary && (
          <Truncate lines={3} ellipsis="...">
            <WysiwygField
              html={summary}
            />
          </Truncate>
        )}
        {themes.length > 0 &&
          <ThemesLabels themes={themes.slice(0, 2)} />}
      </div>
    </div>
  );
};

export default EntityTeaserSmall;
